module.exports = __webpack_public_path__ + "static/9bcb6877.second-group-img.png";